var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemTwoThumbsUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M18.851 17.995h-1.973l1.098-6.592c.004-.022.001-.045.004-.067h1.979zm-4 .002H8.326v-7.046l.356-.624 2.462-4.316a.951.951 0 0 1 .82 1.085l-.279 1.954-.326 2.287h4.6zm.294-11.986a.954.954 0 0 1 .819 1.084l-.278 1.955-.041.284h-1.98l.138-.971zM4.001 17.997h2.325v-6.66H4.001zm16.224-8.664h-2.56l.279-1.955a2.958 2.958 0 0 0-3.046-3.376c-.594.025-1.127.38-1.422.896l-.14.246A2.93 2.93 0 0 0 11.018 4l-.121.002c-.594.025-1.127.38-1.422.896l-2.53 4.436H3.776c-.981 0-1.776.795-1.776 1.778v7.11C2 19.204 2.795 20 3.776 20h11.265l.018-.002h3.982c.869 0 1.609-.628 1.751-1.485l1.184-7.11a1.777 1.777 0 0 0-1.751-2.07"
})));
export default SvgGemTwoThumbsUp;